<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_43"></a>For Jo Lynda Watts. Mom, you’re the bomb! —T. F.</p>
<p class="dedication1">To everyone affected by Hurricane Irma. —E. L.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03dedication.vue?3fdc8c40